export const STORAGE_KEYS = {
  CITY_LIFE: 'city_life', //定位缓存
  LAT_LNG: 'lat_lng',
  PRODUCT_CELL_CLICK_PARAM: 'prodcut_cell_click_param', //全屏预览页里用到的商品点击埋点参数
  PREVIEW_IMAGES: 'preview_images' //全屏预览页里用到的显示图片
}

export const COOKIE_KEYS = {
  CITY_SERVICE: 'city_service', //life.cekid.com/h5/city-choose城市选择
  CITY_SERVICE_INH5: 'city_service_set_in_h5',
  CITYCODE: 'citycode' //app收货地址城市
}
